import React from 'react';

const UnderConstruction = () => {
  return (
    <div style={{
      height: '100vh',
      width: '100%',
      backgroundColor: '#f9fafb',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Segoe UI, sans-serif',
      padding: '20px',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '4rem' }}>🚧</div>
      <h1 style={{ fontSize: '2.5rem', color: '#f59e0b', margin: '20px 0 10px' }}>
      The site is currently undergoing renovations.
      </h1>
    </div>
  );
};

export default UnderConstruction;
